import { Outlet } from "react-router-dom";
import logo from "../../assets/MH blue.png";

const SupplierRegistrationLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#F6F7F4]">
      <main className="flex-1 sr-font-body">
        <div className="mx-auto px-4 md:px-20 pt-8 pb-28">
          <div className="flex flex-col items-center py-16 text-white bg-blue-500 mb-10 rounded-t-xl">
            <div className="flex items-center justify-center mb-4 bg-white rounded-full w-40 h-40">
              <img src={logo} alt="logo" className="w-32 h-32" />
            </div>
            <h1 className="mt-3 text-2xl font-semibold">
              MH Supplier Registration Form
            </h1>
          </div>
          <div className="bg-white rounded-2xl border border-[#E1E5E2] shadow-[0_1px_3px_rgba(22,50,79,0.04),0_8px_24px_rgba(22,50,79,0.05)] p-6">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
};

export default SupplierRegistrationLayout;
